package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagGb: ImageVector
    get() {
        if (_flagGb != null) {
            return _flagGb!!
        }
        _flagGb = Builder(name = "FlagGb", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF012169)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(512.0f, 0.0f)
                    lineTo(512.0f, 64.0f)
                    lineTo(322.0f, 256.0f)
                    lineTo(512.0f, 443.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(445.0f, 512.0f)
                    lineTo(254.0f, 324.0f)
                    lineTo(68.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 444.0f)
                    lineTo(186.0f, 257.0f)
                    lineTo(0.0f, 74.0f)
                    lineTo(0.0f, 0.0f)
                    lineTo(62.0f, 0.0f)
                    lineTo(254.0f, 188.0f)
                    lineTo(440.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFC8102E)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(184.0f, 324.0f)
                    lineTo(195.0f, 358.0f)
                    lineTo(42.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 509.0f)
                    lineTo(184.0f, 324.0f)
                    close()
                    moveTo(308.0f, 312.0f)
                    lineTo(362.0f, 320.0f)
                    lineTo(512.0f, 467.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(308.0f, 312.0f)
                    close()
                    moveTo(512.0f, 0.0f)
                    lineTo(320.0f, 196.0f)
                    lineTo(316.0f, 152.0f)
                    lineTo(466.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    close()
                    moveTo(0.0f, 1.0f)
                    lineTo(193.0f, 190.0f)
                    lineTo(134.0f, 182.0f)
                    lineTo(0.0f, 49.0f)
                    lineTo(0.0f, 1.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(176.0f, 0.0f)
                    lineTo(176.0f, 512.0f)
                    lineTo(336.0f, 512.0f)
                    lineTo(336.0f, 0.0f)
                    lineTo(176.0f, 0.0f)
                    close()
                    moveTo(0.0f, 176.0f)
                    lineTo(0.0f, 336.0f)
                    lineTo(512.0f, 336.0f)
                    lineTo(512.0f, 176.0f)
                    lineTo(0.0f, 176.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFC8102E)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 208.0f)
                    lineTo(0.0f, 304.0f)
                    lineTo(512.0f, 304.0f)
                    lineTo(512.0f, 208.0f)
                    lineTo(0.0f, 208.0f)
                    close()
                    moveTo(208.0f, 0.0f)
                    lineTo(208.0f, 512.0f)
                    lineTo(304.0f, 512.0f)
                    lineTo(304.0f, 0.0f)
                    lineTo(208.0f, 0.0f)
                    close()
                }
            }
        }
        .build()
        return _flagGb!!
    }

private var _flagGb: ImageVector? = null
